/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps, useParams } from 'react-router-dom';
import { getUrlParameter, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { getSurveillants } from './surveillant.reducer';
import { Table, Button, Space, Spin, Tag } from 'antd';
import { Storage } from 'react-jhipster';
const { Column, ColumnGroup } = Table;
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { schoolId } from 'app/sessionUtils';
import { getEcole } from '../ecole/ecole.reducer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';
import { getSession } from 'app/shared/reducers/authentication';
export const Surveillant = (props: RouteComponentProps<{ ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const { match } = props;
  const surveillantList = useAppSelector(state => state.surveillant.entities);
  const loading = useAppSelector(state => state.surveillant.loading);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const isNotComptable = !useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.COMPTABLE]));

  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getSession());
    dispatch(getSurveillants(props.match.params.ecoleid));
  }, []);
  const isSurveillantGeneral = useAppSelector(state =>
    hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.SURVEILLANT_GENERAL])
  );
  const columns = [
    {
      title: 'Matricule',
      dataIndex: 'matricule',
      key: 'matricule',
    },
    {
      title: 'Prénom',
      dataIndex: 'prenom',
      key: 'prenom',
    },
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
    },
    {
      title: 'E-Mail',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      render: role => <Tag color="gray">{role}</Tag>,
    },
    {
      title: 'Option',
      key: 'action',
      dataIndex: 'id',
      render: id => (
        <Space size="middle">
          <Button type="primary" style={{ height: 30, width: 45 }}>
            <Link to={`/surveillant/${currentEcole && currentEcole.id}/${id}/details`}>
              <FontAwesomeIcon icon="eye" />{' '}
            </Link>
          </Button>
        </Space>
      ),
    },
  ];

  const data = isSurveillantGeneral
    ? surveillantList
        .filter(s => s.authorities === 'ROLE_SURVEILLANT')
        .map((surveillant, i) => ({
          id: surveillant.id,
          nom: surveillant.lastName,
          prenom: surveillant.firstName,
          matricule: surveillant.matricule,
          email: surveillant.email,
          role: surveillant.authorities.map(s => s),
        }))
    : surveillantList.map((surveillant, i) => ({
        id: surveillant.id,
        nom: surveillant.lastName,
        prenom: surveillant.firstName,
        matricule: surveillant.matricule,
        email: surveillant.email,
        role: surveillant.authorities.map(s => s),
      }));

  return (
    <div>
      <h2 id="surveillant-heading" data-cy="SurveillantHeading">
        <Translate contentKey="korischoolApp.surveillant.home.title">Surveillants</Translate>
        {isNotComptable && (
          <div style={{ textAlign: 'right' }}>
            &nbsp;
            <Link
              to={`/surveillant/${currentEcole && currentEcole.id}/new`}
              className="btn jh-create-entity"
              style={{ backgroundColor: '#F28E19', color: 'white' }}
              id="jh-create-entity"
              data-cy="entityCreateButton"
            >
              <FontAwesomeIcon icon="plus" />
              &nbsp;
              <Translate contentKey="korischoolApp.surveillant.home.createLabel">Create new Surveillant</Translate>
            </Link>
          </div>
        )}
      </h2>
      <div className="table-responsive">
        <Spin spinning={loading} tip="Chargement...">
          <Table columns={columns} dataSource={data} bordered pagination={{ pageSize: 10 }} />
        </Spin>
      </div>
    </div>
  );
};

export default Surveillant;
